export const RANK_CONFIG = {
  1: {
    badgeClass: "w-10 h-14 rounded-xl bg-primary items-center justify-center",
    rankTextClass: "text-chalk font-black text-xl",
    avatarSize: 48,
  },
  2: {
    badgeClass: "w-10 h-11 rounded-xl bg-primary-1 items-center justify-center",
    rankTextClass: "text-primary font-black text-lg",
    avatarSize: 44,
  },
  3: {
    badgeClass: "w-10 h-9 rounded-xl bg-primary-2 items-center justify-center",
    rankTextClass: "text-slate font-black text-sm",
    avatarSize: 36,
  },
} as const;